"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var fp = require("fp-ts");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./style.scss");
var react_sortable_tree_1 = require("react-sortable-tree");
var recompose_1 = require("recompose");
var theme_1 = require("./theme");
__exportStar(require("./constants"), exports);
require("./folderTree.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FolderTree'), recompose_1.pure);
// TODO: SortableTree is deprecated and should be replaced with custom implementation
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'folder-structure-tree', style: props.style },
    React.createElement(sok_ui_1.Grid.Row, null,
        React.createElement(sok_ui_1.Grid.Column, { medium: 12 },
            React.createElement("div", { className: 'folder-structure-tree-folder-tree' },
                React.createElement(react_sortable_tree_1.default, { treeData: props.showRoot === true
                        ? [props.tree.getRoot()]
                        : __spreadArray([], props.tree.getRoot().getChildren(), true), isVirtualized: false, canDrag: false, onChange: fp.function.constant(undefined), onVisibilityToggle: function (_a) {
                        var expanded = _a.expanded, node = _a.node;
                        if (props.changeExpand) {
                            props.changeExpand(expanded, node);
                        }
                        if (expanded === true && node.getChildren().length === 0) {
                            props.getContent(node.getValue());
                        }
                        return;
                    }, theme: (0, theme_1.default)(props), generateNodeProps: props.generateNodeProps, placeholderRenderer: function () { return ''; } })))))); });
